export default "__VITE_PUBLIC_ASSET__9911e438__"